import { toast } from 'react-toastify'
import Text from './Text';

const customToast = ({ type, message, callback }) => {
    const supportedTypes = ['success', 'info', 'warning', 'error'];
    if (!supportedTypes.find(x => x === type)) {
        throw new Error(`${type} is not a supported type`);
    }
    toast[type](<Text text={message} />, { onClose: callback });
}

export default customToast
